<template>
    <div
        :class="classNoResultCta"
        class="no-result-cta"
        @click.prevent.stop="openSpeakToExpertModal"
    >
        <h3 class="title">
            {{ title }}
        </h3>

        <div class="description">
            <p>
                {{ t('diamond_search.no_results_description') }}
            </p>

            <Icon
                class="icon"
                icon="angle-right"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { GemsApi_StoneCategory } from '@/graphql/api'

import { assertNever } from '@/helpers'
import { useSpeakToExpertModal } from '@/composables/app/useSpeakToExpertModal.ts'

import Icon from '@/components/ui/icon/Icon.vue'

const { small, category } = defineProps<{
    small?: boolean
    category: GemsApi_StoneCategory
}>()

const { open: openSpeakToExpertModal } = useSpeakToExpertModal()

const { t } = useI18n()

const title = computed(() => {
    switch (category) {
        case 'GEMSTONE':
            return t('diamond_search.no_results_title_gemstones')
        case 'DIAMOND':
        // fallthrough
        case 'FANCY_DIAMOND':
        // fallthrough
        case 'LAB_GROWN_FANCY_DIAMOND':
        // fallthrough
        case 'LAB_GROWN_DIAMOND':
            return t('diamond_search.no_results_title_diamonds')
        default:
            return assertNever(
                category,
                t('diamond_search.no_results_title_generic')
            )
    }
})

const classNoResultCta = computed(() => ({
    small,
}))
</script>

<style lang="scss" scoped>
.no-result-cta {
    color: $white;
    background-color: $blue;
    font-family: $sectra-font-stack;
    display: flex;
    flex-direction: column;
    padding: 30px;
    cursor: pointer;

    .title {
        font-size: 25px;
        margin-bottom: 1em;
    }

    .description {
        font-size: 14px;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .icon {
            margin-left: 30px;
        }
    }

    &.small {
        padding: 20% 10px 10px;

        @include min-width(640) {
            padding: 20% 20px 20px;
        }

        .title {
            font-size: 1.1rem;
        }

        .description {
            flex: 1;
            flex-direction: column;
            justify-content: space-between;
            font-size: 0.9rem;
        }
    }
}
</style>
